import React, { Component } from 'react'


//const API = 'https://hn.algolia.com/api/v1/search?query=';
//const DEFAULT_QUERY = 'redux';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
    };
  }

  componentDidMount() {
    fetch('https://www.googleapis.com/blogger/v3/blogs/80960766310773770/posts?key=AIzaSyCyVj2mGYPc3qgfpkC9r0wlqGqb-WBKPJY')
    //fetch('https://www.googleapis.com/blogger/v3/blogs/80960766310773770/posts?key=AIzaSyCyVj2mGYPc3qgfpkC9r0wlqGqb-WBKPJY'&fields=kind,items(title,))
  
      .then(response => response.json())
      .then(data => this.setState({ items: data.items }));
  }

  render() {
    const { items } = this.state;
    
    return (
      <ul>
        {items.map(item =>
          <li key={item.id}>
            <a href={item.url}>{item.title}</a>
            {/* <div> {item.content}</div> */}
          </li>
        )}
      </ul>
    );
  }
}


export default App;


  /*  componentDidMount() {
        fetch('https://www.googleapis.com/blogger/v3/blogs/80960766310773770/posts?key=AIzaSyCyVj2mGYPc3qgfpkC9r0wlqGqb-WBKPJY')
        //fetch ('https://www.blogger.com/feeds/80960766310773770/posts/default?alt=json')
        //fetch('https://randomuser.me/api/?results=500')
        //fetch('https://www.googleapis.com/blogger/v2/blogs/3213900/posts/8398240586497962757?callback=handleResponse&key=AIzaSyCyVj2mGYPc3qgfpkC9r0wlqGqb-WBKPJY')
        //fetch('http://polarisinvesting.blogspot.com/feeds/posts/default?alt=json')
        .then(results => {
            return results.json();
        }).then(data => {
            data.results.map((items) => {
                return(
                    <div key={items.results}>
                    <img src={items.picture.medium} />
                    </div>
                )
            })
            this.setState({pictures: pictures});
            console.log("state", this.state.pictures);
        })
    }
render() {
    return(

<div className="container2"> 
    <div className="container1">
        {this.state.pictures}
    </div>
 </div>       

    )
}

}
export default Background
*/


// WEBPACK FOOTER //
// ./src/components/getBlogs.js